import { Breadcrumb } from "flowbite-react";
import { H4 } from "../typography/H4";

interface Props {}

export const AdminOrderHeader: React.FC<Props> = ({}) => {
  return (
    <div className="flex flex-col">
      <Breadcrumb className="pb-0">
        <Breadcrumb.Item>발주 관리</Breadcrumb.Item>
        <Breadcrumb.Item>발주 관리</Breadcrumb.Item>
      </Breadcrumb>
      <div className="flex items-center justify-between h-[50px] mb-[12px]">
        <div className="mt-[15px] mb-[7px] flex gap-[12px]">
          <H4>발주 관리</H4>
          <div />
          {/* <div className="py-[3px]">
            <Body14Regular className="text-semantic-text-secondary">
              파트너들의 견적서 발행 내역을 확인할 수 있습니다.
            </Body14Regular>
          </div> */}
        </div>
        <div />
        {/* <Button
          disabled={disabled}
          color={disabled ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
          onClick={onClickButton}
        >
          정보 저장
        </Button> */}
      </div>
    </div>
  );
};
